import { QueryLazyOptions } from "@apollo/client";
import Autocomplete from "@saleor/components/AutocompleteForObject";
import { Exact } from "@saleor/graphql";
import useLocalPaginator, {
  useLocalPaginationState
} from "@saleor/hooks/useLocalPaginator";
import uniqBy from "lodash/uniqBy";
import React, { useEffect, useRef, useState } from "react";
interface IProps {
  handleSelectedSearch?: (value: any) => void;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  first?: number;
  isClean?: boolean;
  contained: boolean;
  isWidthAuto?: boolean;
  isSearchIcon?: boolean;
  name?: string;
  totalCount?: number;
  getDataSuggestions: (
    options?: QueryLazyOptions<
      Exact<{
        filter?: any;
        first?: number;
      }>
    >
  ) => void;
  fetchDataSuggestions?: any;
  payload?: any;
  loadingDataSuggestion: boolean;
  dataOptions: any[];
  error?: boolean;
  searchField: string;
  objectSuggestion?: boolean;
  defaultInputValue?: string;
  defaultValue?: any;
  withNonSelect?: boolean;
  inputValue?: boolean;
  disabled?: boolean;
  pageInfo?: any;
  showLoadMore?: boolean;
  disableDuplicationLoading?: boolean;
  isCheckingRole?: boolean;
  id?: string;
  onMouseLeave?(event: any);

  onClear?(event?: any);
}

interface LastItemParamsProps {
  id: string;
  position: number;
}

const InputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    handleSelectedSearch,
    placeholder,
    first,
    isClean,
    contained,
    isWidthAuto,
    isSearchIcon,
    totalCount,
    getDataSuggestions,
    loadingDataSuggestion,
    dataOptions,
    error,
    searchField,
    payload,
    objectSuggestion,
    onMouseLeave,
    defaultInputValue,
    defaultValue,
    withNonSelect,
    disabled,
    pageInfo,
    showLoadMore,
    disableDuplicationLoading,
    id
  } = props;

  const firstRender = useRef(true);
  const [value, setValue] = useState<string>("");
  const [opts, setOpts] = useState<any[]>([]);
  const [
    valuesPaginationState,
    setValuesPaginationState
  ] = useLocalPaginationState(100);
  const paginateValues = useLocalPaginator(setValuesPaginationState);
  const { loadNextPage } = paginateValues(pageInfo, valuesPaginationState);
  const [lastItemParams, setLastItemParams] = useState<LastItemParamsProps>(
    null
  );

  useEffect(() => {
    if (firstRender.current && !value && defaultInputValue && defaultValue) {
      setValue(defaultInputValue);
      firstRender.current = false;
    }
  }, [defaultInputValue, defaultValue, firstRender.current]);

  const handleChange = event => {
    setValue(event);
  };

  const onLastItemVisible = (id: string, position: number) => {
    setLastItemParams({ id, position });
    loadNextPage();
  };

  useEffect(() => {
    if (value?.length >= 2) {
      const filterObj = { [searchField]: value };
      getDataSuggestions({
        variables: {
          first: first || 100,
          filter: filterObj,
          ...payload
        }
      });
    }
  }, [value]);

  useEffect(() => {
    if (!disableDuplicationLoading) {
      const uniqOpts = uniqBy([...opts, ...dataOptions], "value");
      setOpts(uniqOpts);
    } else {
      setOpts(dataOptions);
    }

    if (lastItemParams?.id) {
      setTimeout(() => {
        const { id: lastItemId, position } = lastItemParams;
        const el = document.getElementById(lastItemId);
        if (el) {
          el.scrollTo({ top: position });
        }
      }, 100);
    }
  }, [dataOptions]);

  useEffect(() => {
    setLastItemParams(null);
  }, [value]);

  return (
    <div>
      <Autocomplete
        contained={contained}
        isWidthAuto={isWidthAuto}
        isSearchIcon={isSearchIcon}
        defaultInputValue={defaultInputValue}
        optionsProp={opts}
        placeholderProps={placeholder}
        totalCount={totalCount || opts.length}
        onLastItemVisible={showLoadMore && onLastItemVisible}
        onChangeProps={e => {
          handleChange(e);
          if (withNonSelect) {
            handleSelectedSearch(e);
          }
        }}
        loading={loadingDataSuggestion}
        onSearch={handleSelectedSearch}
        objectSuggestion={objectSuggestion}
        isReset={isClean}
        defaultValue={defaultValue}
        onMouseLeave={onMouseLeave}
        error={error}
        disabled={disabled}
        id={id}
      />
    </div>
  );
};

export default InputSuggestion;
